import { CommonEvents, Preferences } from '@3ds/common-preferences'
import { message } from 'vuekit'

import { MESSAGE_TIMEOUT_ERROR } from '@ds/swymkit/config'

import { proxifyUrl } from '~/features-shared/libs/utils/url-utils'

import { fetchFileData } from '~/features-generic/compass/api/legal'
import { APP_NATIVE_EVENTS } from '~/features-generic/mobile/utils/mobile-event-integration'

interface envInfo {
  file: string
  envid: string
  type: string
  ressourceType: string | undefined
}

/**
 *
 * @param envInfo - object of file data
 * @param language - language
 * @param compassUrl - compassUrl
 * @description - this function will download the file on click
 */
// eslint-disable-next-line max-statements
export async function getLegalInfoFiles(envInfo: envInfo, language: string, compassUrl: string) {
  let fileType = envInfo.type
  switch (fileType) {
    case 'tou':
      fileType = 'tos'
      break
    case 'cookie':
      fileType = 'cookies'
      break
    case 'legalInfo'.toLowerCase():
      fileType = 'legalInfos'
      break
    default:
      break
  }

  const params = {
    envid: envInfo.envid,
    file: envInfo.file,
    type: fileType,
  }
  const fileName = envInfo.file
  const ressourceType = envInfo && envInfo.ressourceType

  if (ressourceType === 'url') {
    window.open(envInfo.file, '_blank')
  }
  else {
    let fileData
    try {
      fileData = await fetchFileData(compassUrl, language, params)
    }
    catch (error: any) {
      message.create({ text: error.message, color: 'error', timeout: MESSAGE_TIMEOUT_ERROR })
    }

    if (fileData) {
      const fileExtension = fileName.split('.')
        .pop()
      const queryString = new URLSearchParams()
      queryString.append('__fcs__failurePage', `${compassUrl}/resources/AppsMngt/uploadfile/message?error=true`)
      queryString.append('__fcs__jobTicket', fileData.fcsJobTicket)
      queryString.append('file_0_name', fileName)
      queryString.append('__fcs__attachment', 'true')
      const finalQuery = queryString.toString()
      const downloadUrl = `${fileData.fcsUrl}?${finalQuery}`

      if (Preferences.isNativeApp()) {
        CommonEvents.emitEventToNativeApp(CommonEvents.EVENTS.NOTIFY_APP_DOWNLOAD_URL, {
          downloadUrl: proxifyUrl(downloadUrl),
          extension: fileExtension ?? '',
          originalName: fileName,
        })
      }
      else {
        window.open(downloadUrl, '_blank')
      }
    }
  }
}
